.linkform {
  width: 26rem;
}

.linkform__input-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.linkform__footer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

.linkform__input-url-wrapper {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
  width: 100%;
}

.linkform__input-url-wrapper div {
  width: 100%;
}

.linkform__open-url-button {
  align-items: center;
  aspect-ratio: 1/1;
  background-color: var(--color-uva-white);
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  height: 2.75rem;
  justify-content: center;
  width: 2.75rem;
}

.linkform__open-url-button:hover {
  background-color: var(--color-grey-400);
  border: 1px solid var(--color-grey-700);
}

.linkform__open-url-button:active {
  background-color: var(--color-uva-black);
  border: 1px solid var(--color-uva-black);
  color: var(--color-uva-white);
}

.editor__toolbar-button:active:hover {
  color: var(--color-uva-white);
}
